import React from 'react';
import { isOrdenTrabajoVencida } from '../../utils/dateHelpers';

/**
 * Card de orden de trabajo para el calendario
 * @param {Object} props - Propiedades del componente
 * @param {Object} props.ordenTrabajo - Objeto de orden de trabajo
 * @param {Function} props.onClick - Callback al hacer click
 * @returns {JSX.Element}
 */
function OrdenTrabajoCalendarCard({ ordenTrabajo, onClick }) {
  /**
   * Maneja el click en el card con validación
   */
  const handleClick = () => {
    if (ordenTrabajo && onClick) {
      onClick(ordenTrabajo);
    }
  };

  const vencido = isOrdenTrabajoVencida(ordenTrabajo.fecha_ejecucion, ordenTrabajo.estado);

  // Mapeo de estados a clases CSS
  const estadoClass = {
    programado: vencido ? 'card-vencido' : 'card-programado',
    en_progreso: 'card-en-progreso',
    completado: 'card-completado',
    cancelado: 'card-cancelado'
  }[ordenTrabajo.estado] || 'card-programado';

  // Mapeo de prioridades a íconos
  const prioridadIcon = {
    critica: 'fa-exclamation',
    alta: 'fa-arrow-up',
    media: 'fa-minus',
    baja: 'fa-arrow-down'
  }[ordenTrabajo.prioridad] || 'fa-minus';

  return (
    <div
      className={`orden-trabajo-calendar-card ${estadoClass}`}
      onClick={handleClick}
      title={`${ordenTrabajo.equipo?.codigo || 'Sin equipo'} - ${ordenTrabajo.tipo_mantenimiento?.nombre || 'Sin tipo'}`}
    >
      {vencido && <i className="fas fa-exclamation-triangle card-warning-icon"></i>}

      <div className="card-content">
        <span className="card-priority">
          <i className={`fas ${prioridadIcon}`}></i>
        </span>

        <span className="card-equipo">
          {ordenTrabajo.equipo?.codigo || 'N/A'}
        </span>

        <span className="card-tipo badge badge-sm">
          {ordenTrabajo.tipo_mantenimiento?.nombre || 'N/A'}
        </span>
      </div>
    </div>
  );
}

export default OrdenTrabajoCalendarCard;
